<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" style="font-size: 14px" class="text-center">
          Li e concordo com os
          <span style="color: #0077ff"> termos de uso e política de privacidade </span>
        </div>
      </template>

      <v-card>
        <v-card-title class="text-h5" style="color: #02a554">
          Política de privacidade
        </v-card-title>

        <v-card-text>
          Ao subscrever esta autorização, está a autorizar o (A) Ines Cristina Miranda Mata Cunha da
          Silva a enviar instruções ao seu banco para debitar a sua conta e (B) o seu banco a
          debitar a sua conta, de acordo com as instruções do @Ondivan. Os seus direitos incluem a
          possibilidade de exigir do seu Banco o reembolso do montante debitado, nos termos e
          condições acordados com o seu banco. O reembolso deve ser solicitado até um prazo de oito
          semanas, a contar da data do débito na sua conta.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style></style>
